module.exports = __webpack_public_path__ + "assets/img/spotify-logo.07835573.png";